/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
import MaterialReactTable from 'material-react-table';
import toast, { Toaster } from 'react-hot-toast';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Container, Box, Tooltip, IconButton } from '@mui/material';
import { Mail } from '@mui/icons-material';
// import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
// import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
// import { getProducts } from '../../../redux/Weedowl/Weedowlproduct';
import axiosInstance from '../../../utils/axios';
// import SendEmail from './SendEmail';

export default function Itineraries() {
  const { themeStretch } = useSettings();

  const navigate = useNavigate();
  const [Data, setdata] = useState([]);
  const GetYear = () => {
    axiosInstance
      .get('api/subadmin/itineraries')
      .then((response) => {
        // console.log(response.data)
        if (response?.data) {
          // console.log(response?.data);
          setdata(response?.data?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    GetYear();
  }, []);

  useEffect(() => {}, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'ID',
        size: 50,
      },

      {
        accessorKey: 'title',
        header: 'Name',
        size: 10,
        // Cell: ({ row }) => <p>{row?.original?.title ? row?.original?.title : 'Empty'}</p>,
      },
      {
        accessorKey: 'client',
        header: 'client',
        size: 10,
        Cell: ({ row }) => <p>{row?.original?.client?.family_name}</p>,
      },
      {
        accessorKey: 'travel_type',
        header: 'traveltype',
        size: 10,
      },
      {
        accessorKey: 'destination',
        header: 'Destination',
        size: 10,
      },

      {
        accessorKey: 'action',
        header: 'Action',
        size: 100,
        Cell: ({ row }) => {
          const id = row.original.id;

          return (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Edit">
                <IconButton onClick={() => navigate(`/dashboard/update-an-itinerary/${id}`, { state: row?.original })}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Delete">
                <IconButton color="error" onClick={() => handledelete(id)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Send Mail">
                <IconButton color="secondary" onClick={() => navigate(`/dashboard/sendmail/${id}`)}>
                  <Mail />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handledelete = async (id) => {
    await axiosInstance
      .delete(`api/subadmin/itineraries/${id}`)
      .then((res) => {
        if (res.status === 200) {
          toast.success('Deleted Succesfully');
          GetYear();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Page title="Travel+: Category And Services">
        <Toaster position="top-right" reverseOrder={false} />
        <Container maxWidth={themeStretch ? false : 24}>
          <HeaderBreadcrumbs
            heading="Travel Itineraries"
            links={[<></>]}
            action={
              <></>
              //   <Button
              //     variant="contained"
              //     startIcon={<Iconify icon="eva:plus-fill" />}
              //     component={RouterLink}
              //     to={`/dashboard/addservices`}
              //   >
              //      Travel Itineraries
              //   </Button>
            }
          />

          <Card>
            <MaterialReactTable columns={columns} data={Data} />
          </Card>
        </Container>
        {/* <SendEmail/> */}
      </Page>
    </>
  );
}
